import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Pagin from 'src/components/common/Pagin';
import { getDetailPagin } from 'src/common/helper';

const PatientTab = (props: any) => {
  return (
    <>
      <TableContainer component={Paper}>
        <Table
          sx={{
            minWidth: 650,
            '& .MuiTableCell-root.MuiTableCell-head': {
              borderBottom: '1px solid #F3F3F3',
              fontWeight: 700,
              p: '6px 16px',
              fontSize: '12px',
              minWidth: '100px',
            },
            '& .MuiTableCell-root.MuiTableCell-body': {
              color: 'primary.dark',
              fontSize: '12px',
              py: '10px',
            },
          }}
          aria-label='simple table'
        >
          <TableHead>
            <TableRow>
              <TableCell>患者ID</TableCell>
              <TableCell>患者名</TableCell>
              <TableCell>メールアドレス</TableCell>
              <TableCell>電話番号</TableCell>
              <TableCell>性別</TableCell>
              <TableCell>生年月日</TableCell>
              <TableCell>住所</TableCell>
              <TableCell>サロン番号</TableCell>
              <TableCell>アイコン</TableCell>
              <TableCell>VIPフラグ</TableCell>
              <TableCell>メモ</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.data.map((row: any, index: number) => (
              <TableRow
                key={index}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                }}
              >
                <TableCell>{row.patientno}</TableCell>
                <TableCell>{row.fullname}</TableCell>
                <TableCell>{row.email}</TableCell>
                <TableCell>{row.phone1}</TableCell>
                <TableCell>{row.gender}</TableCell>
                <TableCell>{row.dob}</TableCell>
                <TableCell>{row.address}</TableCell>
                <TableCell>{row.salon_no}</TableCell>
                <TableCell>{row.icons}</TableCell>
                <TableCell>{row.vip === 0 ? '' : '✓'}</TableCell>
                <TableCell>{row.note}</TableCell>
              </TableRow>
            ))}
            {props.data.length === 0 && (
              <TableRow>
                <TableCell
                  colSpan={11}
                  sx={{ textAlign: 'center', verticalAlign: 'center' }}
                >
                  データがありません
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {props.data.length > 0 && props.pagination && (
        <Box display={'flex'} justifyContent={'right'} mt={'10px'}>
          <Typography
            component='label'
            sx={{
              color: '#AAB2BD',
              fontWeight: '400',
              fontSize: '10px',
              lineHeight: '12px',
            }}
          >
            {getDetailPagin(props.pagination)}
          </Typography>
        </Box>
      )}
      {props.data.length > 0 && props.pagination && props.pagination.page && (
        <Pagin
          handlePageChange={props.handlePageChange}
          pagination={props.pagination}
        />
      )}
    </>
  );
};
export default PatientTab;
